export default __webpack_public_path__ + "static/banner-how-your-car-can-save-you-money-9d72de31753541be0c7e482a6f630d57.jpg";